// extracted by mini-css-extract-plugin
export var Avatar = "style-module--Avatar--45e70";
export var Contact = "style-module--Contact--b570c";
export var ContactDetails = "style-module--ContactDetails--7cc97";
export var Description = "style-module--Description--6f980";
export var Name = "style-module--Name--0fae3";
export var Profile = "style-module--Profile--8a1d1";